import { render, staticRenderFns } from "./CButtonGroup.vue?vue&type=template&id=0d5304e6&scoped=true&"
import script from "./CButtonGroup.vue?vue&type=script&lang=js&"
export * from "./CButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./CButtonGroup.vue?vue&type=style&index=0&id=0d5304e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5304e6",
  null
  
)

export default component.exports